import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=51c2bc3d&scoped=true&lang=pug&"
import script from "./PropertyList.vue?vue&type=script&lang=js&"
export * from "./PropertyList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=51c2bc3d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2bc3d",
  null
  
)

export default component.exports